<template>
  <div>
    <banner :title="'产品中心'"></banner>
    <preview v-if="visable" :imgList="honerList" @close="close"></preview>
    <div class="list">
      <div class="l-title">
        <span>
          <b>产品中心</b>
        </span>
      </div>
      <productList></productList>
      <div class="proindex">
        <div class="floor">
          <div class="wrap">
            <div class="container-fluid">
              <div
                class="hd d-flex flex-row justify-content-between align-items-center"
              >
                <div class="left d-flex">
                  <span>F1</span>
                  <div class="txt">
                    <b>布电线</b>
                    <p>致力成为您满意的合作伙伴，为客户提供完善的产品和服务</p>
                  </div>
                </div>
                <a href="/commonp?type=13" class="right">查看更多</a>
              </div>
              <div class="bd">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide swiper-slide-active"
                    role="group"
                    :aria-label="index + 1 + ' / 5'"
                    v-for="(product, index) in bdxProduct"
                    :key="index"
                    style="width: 270px; margin-right: 20px; margin-top: 20px"
                  >
                    <div class="simg">
                      <img :src="product.img" :alt="product.label" />
                      <div>
                        <a :href="'/proinfo?type=' + product.type"
                          ><span class="iconfont icon-sousuo"></span>产品详情</a
                        >
                        <a href="/message#message"
                          ><span class="iconfont icon-kefu"></span>咨询价格</a
                        >
                      </div>
                      <a :href="'/productp?type=' + product.type">
                        <b class="ellipsis">{{ product.label }}</b>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="floor">
          <div class="wrap">
            <div class="container-fluid">
              <div
                class="hd d-flex flex-row justify-content-between align-items-center"
              >
                <div class="left d-flex">
                  <span>F2</span>
                  <div class="txt">
                    <b>电力电缆</b>
                    <p>致力成为您满意的合作伙伴，为客户提供完善的产品和服务</p>
                  </div>
                </div>
                <a href="/commonp?type=14" class="right">查看更多</a>
              </div>
              <div class="bd">
                <div
                  class="swiper-wrapper"
                  id="swiper-wrapper-ec679eb0a726feea"
                  aria-live="polite"
                  style="transform: translate3d(0px, 0px, 0px)"
                >
                  <div
                    class="swiper-slide swiper-slide-active"
                    role="group"
                    :aria-label="index + 1 + ' / 5'"
                    v-for="(product, index) in dldlProduct"
                    :key="index"
                    style="width: 270px; margin-right: 20px; margin-top: 20px"
                  >
                    <div class="simg">
                      <img :src="product.img" :alt="product.label" />
                      <div>
                        <a :href="'/proinfo?type=' + product.type"
                          ><span class="iconfont icon-sousuo"></span>产品详情</a
                        >
                        <a href="/message#message"
                          ><span class="iconfont icon-kefu"></span>咨询价格</a
                        >
                      </div>
                      <a :href="'/productp?type=' + product.type">
                        <b class="ellipsis">{{ product.label }}</b>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="floor">
          <div class="wrap">
            <div class="container-fluid">
              <div
                class="hd d-flex flex-row justify-content-between align-items-center"
              >
                <div class="left d-flex">
                  <span>F3</span>
                  <div class="txt">
                    <b>低烟无卤电缆</b>
                    <p>致力成为您满意的合作伙伴，为客户提供完善的产品和服务</p>
                  </div>
                </div>
                <a href="/commonp?type=17" class="right">查看更多</a>
              </div>
              <div class="bd">
                <div
                  class="swiper-wrapper"
                  id="swiper-wrapper-ec679eb0a726feea"
                  aria-live="polite"
                  style="transform: translate3d(0px, 0px, 0px)"
                >
                  <div
                    class="swiper-slide swiper-slide-active"
                    role="group"
                    :aria-label="index + 1 + ' / 5'"
                    v-for="(product, index) in dywlProduct"
                    :key="index"
                    style="width: 270px; margin-right: 20px; margin-top: 20px"
                  >
                    <div class="simg">
                      <img :src="product.img" :alt="product.label" />
                      <div>
                        <a :href="'/proinfo?type=' + product.type"
                          ><span class="iconfont icon-sousuo"></span>产品详情</a
                        >
                        <a href="/message#message"
                          ><span class="iconfont icon-kefu"></span>咨询价格</a
                        >
                      </div>
                      <a :href="'/productp?type=' + product.type">
                        <b class="ellipsis">{{ product.label }}</b>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../components/banner.vue";
import preview from "../components/preview.vue";
import productList from "../components/productList.vue";
export default {
  components: {
    banner,
    preview,
    productList,
  },
  data() {
    return {
      visable: false,
      bdxProduct: [
        {
          img: "/product/610b62385bf64284a47aaec7ef06be41_800x800.webp",
          label: "布电线",
          type: "13",
        },
        {
          img: "/product/38280a3129cdf17339b0574ac68be736_800x800.webp",
          label: "布电线",
          type: "13",
        },
        {
          img: "/product/2f4f7f959bc4c2747c010382162a0c83_800x800.webp",
          label: "布电线",
          type: "13",
        },
        {
          img: "/product/446ea399af05d311fd3b4ff92f6d73cb_800x800.webp",
          label: "布电线",
          type: "13",
        },
      ],
      dldlProduct: [
        {
          img: "/product/67934d0e5e322b1a6b7168b18baa7e7c_800x800.webp",
          label: "电力电缆",
          type: "14",
        },
        {
          img: "/product/3ee9c39e56b29896c6a4000bd560a5c0_800x800.webp",
          label: "电力电缆",
          type: "14",
        },
        {
          img: "/product/58b93bfba2b354673b707fb78789b20a_800x800.webp",
          label: "电力电缆",
          type: "14",
        },
        {
          img: "/product/20ef201f119ed60b6f7fe3f3cb0e5a09_800x800.webp",
          label: "电力电缆",
          type: "14",
        },
      ],
      dywlProduct: [
        {
          img: "/product/f27221fac6672fba401256fa929df913_800x800.webp",
          label: "低烟无卤电缆",
          type: "17",
        },
        {
          img: "/product/1e9887a06de0c680a6f5137b06efde58_800x800.webp",
          label: "低烟无卤电缆",
          type: "17",
        },
        {
          img: "/product/4646cf99e901176b6366a155265414a3_800x800.webp",
          label: "低烟无卤电缆",
          type: "17",
        },
        {
          img: "/product/a0bffe481c73b8f1fa3efe7c83996c65_800x800.webp",
          label: "低烟无卤电缆",
          type: "17",
        },
      ],
    };
  },
  methods: {
    close() {
      this.visable = false;
    },
    preview() {
      this.visable = true;
    },
  },
};
</script>

<style lang="less" scoped>
.swiper-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.lightbox {
  .item {
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    overflow: hidden;
    transition: all 0.5s;
    border: solid 1px #eee;
    .pic {
      width: 100%;
      height: 250px;
      position: relative;
      overflow: hidden;
      &:after {
        width: 0;
        height: 0;
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.5s;
        border-radius: 50%;
      }
      img {
        width: 95%;
        height: 100%;
        object-fit: contain;
        position: absolute;
      }
      i {
        color: #fff;
        font-size: 50px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        opacity: 0;
        transition: all 0.5s;
      }
    }
    .txt {
      background: #f6f5f5;
      padding: 15px;
      transition: all 0.5s;
      color: #333;
      font-size: 16px;
      font-weight: 700;
    }
    &:hover {
      box-shadow: 0 0 10px #999;
      i {
        opacity: 1;
      }
      .pic:after {
        width: 200%;
        height: 200%;
        left: -50%;
        top: -50%;
      }
      // .txt {
      //   background: @primaryColor;
      //   color: #fff;
      // }
    }
  }
}

.l-title b:after {
  content: "";
  width: 100px;
  height: 3px;
  background: @primaryColor;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 0;
}
.list .warp p {
  text-align: left;
}
</style>
